// Auto-generated from the bedd.dev individual.html snapshot.
// Internal hrefs rewritten to SPA paths via `.scratch/port-page.py`; nav +
// footer are composed from `marketing-shared/` so all marketing pages stay
// in lock-step. To re-port, drop a fresh snapshot at
// `.scratch/bedd-snapshot/individual.html` and re-run the build script.

import { navMarkup } from '../marketing-shared/nav';
import { footerMarkup } from '../marketing-shared/footer';

export const markup = `${navMarkup('individual')}

<!-- ──────────────────────────────────────────────
     HERO — For Individual
─────────────────────────────────────────────── -->
<section class="hero">
  <div class="container">
    <div class="hero-grid">
      <div class="hero-copy">
        <div class="eyebrow hero-eyebrow-anim">For Individual · Revit Assessment</div>
        <h1>
          <span class="word">Stop</span>
          <span class="word accent">guessing.</span>
          <span class="word">Start</span>
          <span class="word accent">proving.</span>
        </h1>
        <p class="lede">
          Benchmark your Revit skills against industry standards. Find out exactly where you stand—then close the gaps.
          <strong>Walk into your next role with proof, not promises.</strong>
        </p>
        <div class="hero-actions">
          <a href="#pricing" class="btn btn-primary btn-magnetic">Start free assessment →</a>
          <a href="#journey" class="btn btn-ghost">See the journey</a>
        </div>
        <div class="hero-trust">Used by Revit professionals in 40+ countries</div>
      </div>

      <div class="hero-mockup">
        <div class="mockup-card mockup-main">
          <div class="mockup-header">
            <div class="mockup-title-block">
              <div class="label">Your Result</div>
              <div class="title">Architecture · Advanced</div>
            </div>
            <div class="mockup-status">87 / 100</div>
          </div>

          <div class="skill-row">
            <div class="skill-name">Modeling</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 94%"></div></div>
            <div class="skill-score">94</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Families</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 88%"></div></div>
            <div class="skill-score">88</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Documentation</div>
            <div class="skill-bar"><div class="skill-fill acc" style="--w: 76%"></div></div>
            <div class="skill-score">76</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Coordination</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 81%"></div></div>
            <div class="skill-score">81</div>
          </div>
          <div class="skill-row">
            <div class="skill-name">Worksharing</div>
            <div class="skill-bar"><div class="skill-fill" style="--w: 90%"></div></div>
            <div class="skill-score">90</div>
          </div>

          <div class="mockup-footer">
            <span><span class="dot"></span>Verified · share on LinkedIn</span>
            <span>ARCH-07</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     COMPARISON BLOCK
─────────────────────────────────────────────── -->
<section class="section">
  <div class="container">
    <span class="section-anchor">02 / The difference</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">The difference</div>
        <h2>What your CV says.<br>What your portfolio shows.<br><span class="accent">What we prove.</span></h2>
      </div>
      <div class="rhs">
        Hiring managers know the gap between what a candidate claims and what they can deliver. BIMAssess closes that gap with verifiable evidence of your Revit ability.
      </div>
    </div>

    <div class="compare-grid reveal-stagger">
      <div class="compare-col">
        <div class="col-tag">Your CV tells them</div>
        <h3>Years on a project.</h3>
        <ul class="compare-list">
          <li><span class="icon no">—</span>Job titles and dates</li>
          <li><span class="icon no">—</span>"Proficient in Revit"</li>
          <li><span class="icon no">—</span>Self-reported skill levels</li>
          <li><span class="icon no">—</span>References that vouch politely</li>
        </ul>
      </div>

      <div class="compare-col">
        <div class="col-tag">Your portfolio shows</div>
        <h3>Output, not process.</h3>
        <ul class="compare-list">
          <li><span class="icon no">—</span>Final renders and drawings</li>
          <li><span class="icon no">—</span>Polished case studies</li>
          <li><span class="icon no">—</span>Team work, hard to attribute</li>
          <li><span class="icon no">—</span>No measure of efficiency</li>
        </ul>
      </div>

      <div class="compare-col featured">
        <div class="col-tag">BIMAssess proves</div>
        <h3>Genuine Revit ability.</h3>
        <ul class="compare-list">
          <li><span class="icon yes"><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 4.5l1.6 1.6 3.4-3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>Industry-aligned competency</li>
          <li><span class="icon yes"><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 4.5l1.6 1.6 3.4-3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>Standardised, comparable scores</li>
          <li><span class="icon yes"><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 4.5l1.6 1.6 3.4-3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>Verifiable digital credentials</li>
          <li><span class="icon yes"><svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 4.5l1.6 1.6 3.4-3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>Built by practising BIM experts</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     SCROLLYTELLING: SKILL JOURNEY
─────────────────────────────────────────────── -->
<section class="scrolly" id="journey">
  <div class="scrolly-grid">
    <div class="scrolly-sticky">
      <div class="scrolly-label">The journey</div>
      <h2 class="scrolly-headline">From novice to<br><span class="accent">BIM Champion.</span></h2>

      <div class="journey-card">
        <div class="journey-stage">Currently</div>
        <div class="journey-current" id="journeyCurrent">Stage <span class="level">01 · Novice</span></div>

        <div class="journey-bars">
          <div class="journey-bar-row" data-level="0">
            <div class="journey-bar-name">Novice</div>
            <div class="journey-bar"><div class="journey-bar-fill" style="--target: 100%"></div></div>
            <div class="journey-bar-score">—</div>
          </div>
          <div class="journey-bar-row" data-level="1">
            <div class="journey-bar-name">Foundation</div>
            <div class="journey-bar"><div class="journey-bar-fill" style="--target: 92%"></div></div>
            <div class="journey-bar-score">—</div>
          </div>
          <div class="journey-bar-row" data-level="2">
            <div class="journey-bar-name">Intermediate</div>
            <div class="journey-bar"><div class="journey-bar-fill" style="--target: 78%"></div></div>
            <div class="journey-bar-score">—</div>
          </div>
          <div class="journey-bar-row" data-level="3">
            <div class="journey-bar-name">Advanced</div>
            <div class="journey-bar"><div class="journey-bar-fill" style="--target: 71%"></div></div>
            <div class="journey-bar-score">—</div>
          </div>
          <div class="journey-bar-row" data-level="4">
            <div class="journey-bar-name">BIM Champion</div>
            <div class="journey-bar"><div class="journey-bar-fill" style="--target: 88%"></div></div>
            <div class="journey-bar-score">—</div>
          </div>
        </div>
      </div>
    </div>

    <div class="scrolly-steps">
      <div class="scrolly-step" data-step="0" data-label="Stage 01 · Novice">
        <div class="step-num">Stage 01</div>
        <h4>Start where you are.</h4>
        <p>The Novice assessment validates the basics—navigation, views, levels, families. No prep needed. It's your true baseline. Most professionals find one or two unexpected gaps.</p>
      </div>
      <div class="scrolly-step" data-step="1" data-label="Stage 02 · Foundation">
        <div class="step-num">Stage 02</div>
        <h4>Build the foundation.</h4>
        <p>Modeling, schedules, simple families, drawing sets. The level required to be productive on real projects. This is where most "intermediate" CVs stop matching reality.</p>
      </div>
      <div class="scrolly-step" data-step="2" data-label="Stage 03 · Intermediate">
        <div class="step-num">Stage 03</div>
        <h4>Move into delivery.</h4>
        <p>Family creation, parametric components, phasing, design options, worksharing. The level employers expect when they hire "BIM Modeler 3+ years."</p>
      </div>
      <div class="scrolly-step" data-step="3" data-label="Stage 04 · Advanced">
        <div class="step-num">Stage 04</div>
        <h4>Lead the model.</h4>
        <p>Complex coordination, advanced families, shared parameters, view templates at scale. The technical core of a senior modeler or BIM coordinator.</p>
      </div>
      <div class="scrolly-step" data-step="4" data-label="Stage 05 · BIM Champion">
        <div class="step-num">Stage 05</div>
        <h4>Set the standard.</h4>
        <p>Office templates, project setup, BIM Execution Plans, automation strategy. The threshold between practitioner and BIM Manager. This is the BIM Champion.</p>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     HOW IT WORKS — Individual
─────────────────────────────────────────────── -->
<section class="section">
  <div class="container">
    <span class="section-anchor">04 / How it works</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">How it works</div>
        <h2>Three steps.<br><span class="accent">No surprises.</span></h2>
      </div>
      <div class="rhs">
        Built to be honest about what it takes—and quick about getting you there. Most assessments are completed in under 90 minutes.
      </div>
    </div>

    <div class="steps-grid reveal-stagger">
      <div class="step">
        <div class="step-num mono">01</div>
        <h3>Choose your assessment.</h3>
        <p>Browse 18 exams across architecture, MEP, structural, and interior tracks. Pick the level that matches where you are—or where you want to go.</p>
      </div>
      <div class="step-arrow">
        <svg width="48" height="12" viewBox="0 0 48 12" fill="none">
          <path d="M0 6h44m0 0l-5-5m5 5l-5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="step">
        <div class="step-num mono">02</div>
        <h3>Take it online.</h3>
        <p>At your own pace, on your own schedule. Real Revit-task scenarios, not multiple-choice trivia. Auto-saved as you go.</p>
      </div>
      <div class="step-arrow">
        <svg width="48" height="12" viewBox="0 0 48 12" fill="none">
          <path d="M0 6h44m0 0l-5-5m5 5l-5 5" stroke="currentColor" stroke-width="1" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="step">
        <div class="step-num mono">03</div>
        <h3>Get verified results.</h3>
        <p>Detailed score breakdown, a verifiable certificate, and a shareable credential—all within 48 hours.</p>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     PRICING — Individual
─────────────────────────────────────────────── -->
<section class="section section-warm" id="pricing">
  <div class="container">
    <span class="section-anchor">05 / Pricing</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">Pricing for individuals</div>
        <h2>Pay once.<br><span class="accent">Or go unlimited.</span></h2>
      </div>
      <div class="rhs">
        Take a single assessment to prove a specific skill, or subscribe for unlimited access to the full catalogue—including ACP prep.
      </div>
    </div>

    <div class="reveal" style="text-align:center; margin-bottom: 2.5rem;">
      <div class="price-toggle">
        <button class="active">Monthly</button>
        <button>Yearly <span class="save-badge">−20%</span></button>
      </div>
    </div>

    <div class="price-grid reveal-stagger" style="grid-template-columns: 1fr 1fr; max-width: 800px; margin: 0 auto;">
      <div class="price-card">
        <div class="price-tag">Pay as you go</div>
        <h3>Single assessment</h3>
        <div class="price-sub">Prove one specific skill.</div>
        <div class="price-amount">
          <span class="num">$29</span>
          <span class="per">/ assessment</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>One assessment of your choice</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Verifiable credential</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Detailed score breakdown</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Email support</li>
        </ul>
        <a href="#" class="btn btn-ghost">Get started</a>
      </div>

      <div class="price-card featured">
        <div class="price-tag">Most popular</div>
        <h3>Professional</h3>
        <div class="price-sub">Unlimited access for serious learners.</div>
        <div class="price-amount">
          <span class="num">$99</span>
          <span class="per">/ month</span>
        </div>
        <ul class="price-features">
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>All 18 assessments</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Retake unlimited times</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Practice mode + full benchmark</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>ACP exam prep included</li>
          <li><svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M3 7l3 3 5-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>Priority support</li>
        </ul>
        <a href="#" class="btn btn-primary">Start 7-day free trial</a>
      </div>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     FAQ — Individual
─────────────────────────────────────────────── -->
<section class="section">
  <div class="container">
    <span class="section-anchor">06 / FAQ</span>
    <div class="section-head reveal">
      <div class="lhs">
        <div class="label">FAQ</div>
        <h2>Quick answers,<br><span class="accent">before you ask.</span></h2>
      </div>
      <div class="rhs">
        Still have questions? <a href="#" style="color:var(--ink);font-weight:500;">Get in touch →</a>
      </div>
    </div>

    <div class="faq-wrap reveal">
      <details class="faq-item" open>
        <summary>How long does an assessment take?</summary>
        <p>Most assessments take 60–90 minutes. You can pause and resume at any time—your progress is auto-saved every 15 seconds.</p>
      </details>
      <details class="faq-item">
        <summary>What if I fail?</summary>
        <p>There is no fail. You get a detailed breakdown of your skills—what you scored well in, where the gaps are, and which exam to take next. On the Professional plan, you can retake any assessment unlimited times.</p>
      </details>
      <details class="faq-item">
        <summary>Is the credential recognized by employers?</summary>
        <p>BIMAssess credentials are recognized by employers across architecture, engineering, and construction—particularly those who already use Autodesk certifications as a hiring signal. Each certificate is verifiable via a unique URL and shareable on LinkedIn.</p>
      </details>
      <details class="faq-item">
        <summary>How is this different from official Autodesk certifications?</summary>
        <p>Autodesk certifications are the formal industry standard—we don't replace them. BIMAssess is your benchmark to know whether you're ready: take our ACP Prep first, see exactly where you'll score, then sit the official exam with confidence.</p>
      </details>
      <details class="faq-item">
        <summary>Can I share my certificate publicly?</summary>
        <p>Yes. Each certified result has a public verification URL, a downloadable PDF certificate, and a shareable badge designed for LinkedIn, your portfolio, or your email signature.</p>
      </details>
      <details class="faq-item">
        <summary>What's the refund policy?</summary>
        <p>If you haven't started an assessment, you can request a full refund within 14 days. The Professional plan includes a 7-day free trial.</p>
      </details>
    </div>
  </div>
</section>

<!-- ──────────────────────────────────────────────
     FINAL CTA
─────────────────────────────────────────────── -->
<section class="final-cta">
  <div class="container">
    <h2>Ready to find out<br>where you <span style="color:#0139B7">stand?</span></h2>
    <p>Take your first assessment free. No card required. Get a verified result in 48 hours.</p>
    <div style="display:flex; gap:12px; justify-content:center; flex-wrap:wrap;">
      <a href="#" class="btn btn-primary btn-magnetic">Start free assessment →</a>
      <a href="/business" data-spa-link class="btn btn-ghost">For Business →</a>
    </div>
  </div>
</section>

${footerMarkup()}`;
